import { assertNever } from '@gitbook/util-ts';

import { getSiteTitle } from '../../Components';
import type { ContentInstallationContext } from './types';

/**
 * Get the content id from an installation context
 */
export function getContentDataFromInstallationContext(context: ContentInstallationContext): {
    id: string;
    title: string;
} {
    switch (context.type) {
        case 'site': {
            return {
                id: context.installation.site.id,
                title: getSiteTitle(context.installation.site.title),
            };
        }
        case 'space': {
            return {
                id: context.installation.space.id,
                title: context.installation.space.title,
            };
        }
        default:
            assertNever(context);
    }
}
